import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import ListParticipantForm from '@src/features/tenant/list-participant/ListParticipantForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function ListParticipant() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <ListParticipantForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default ListParticipant;
